import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import actions from './Actions';
import EditTable from './EditTable';
import PageTemplateTable from '../../components/PageTemplateTable';

let increment = 0;

class EditPage extends PageTemplateTable {
  loadData() {
    this.props.actions.load();
    return;
  }

  addBlankEntry(array) {
    // Check if we need a new blank entry. Don't add one if user cannot edit or there is one already.
    if (array.findIndex((entry) => /^\*/.exec(entry.id) && entry.empty) !== -1) { return; }

    array.push({ id: '*' + increment, name: '', url: '', empty: true });
    increment++;
    return;
  }

  saveChanges(event) {
    event.preventDefault();
    this.setState({ status: { ...this.state.status, editing: true } });
    this.props.actions.update(this.state.local);
  }

  render() {
    return (
      <EditTable
        local={this.state.local}
        onChange={this.onChangeInput}
        onSave={this.saveChanges}
        onDelete={this.onDeleteEntry}
        onRefresh={this.onRefresh}
        hasChanged={this.state.status.hasChanged}
        disable={this.state.status.editing} />
    );
  }
}

function mapStateToProps(state, ownProps) {
  return { reducerState: state.locationState };
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators(actions, dispatch) };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditPage);
